/**
 * Search class - třída s funkcemi pro práci s vyhledávacími formuláři
 */
var Search = window.Search = function () {
    this.lang = $("#langCode").data('lang');
    this.isSkoda = $("body").data('web') == 'SKODA';
    this.tmpCategoryId = null;

    this.priceSliderEl = $('#price_slider_search');
    this.priceFrom = parseInt(this.priceSliderEl.data('default-price-from'));
    this.priceTo = parseInt(this.priceSliderEl.data('default-price-to'));
    this.selectedPriceFrom = parseInt(this.priceSliderEl.data('selected-price-from'));
    this.selectedPriceTo = parseInt(this.priceSliderEl.data('selected-price-to'));

    this.engineCapacitySliderEl = $('#engine_capacity_slider_search');
    this.engineCapacityFrom = parseInt(this.engineCapacitySliderEl.data('default-from'));
    this.engineCapacityTo = parseInt(this.engineCapacitySliderEl.data('default-to'));
    this.selectedEngineCapacityFrom = parseInt(this.engineCapacitySliderEl.data('selected-from'));
    this.selectedEngineCapacityTo = parseInt(this.engineCapacitySliderEl.data('selected-to'));
}

Search.prototype.init = function () {
    // if ($(window).width() < 751) {
    //     $('section.search').hide();
    // }

    var self = this;
    this.initMultiSelect();

    this.isFullSearch = $('.initSearchFull').length > 0 ? true : false;

    if (!this.isFullSearch) {
        this.initSearch();
    } else {
        this.initSearchFull();
    }

    if ($('select.select2-container').length > 0) {
        this.setSelects();
    }

    if (this.priceSliderEl.length) {
        // price slider
        var limitSlider = document.getElementById(this.priceSliderEl.attr('id'));

        noUiSlider.create(limitSlider, {
            start: [this.selectedPriceFrom, this.selectedPriceTo],
            behaviour: 'drag',
            connect: true,
            step: 5000,
            range: {
                'min': this.priceFrom,
                '20%': [150000, 10000],
                '40%': [1000000, 50000],
                '60%': [1500000, 100000],
                '80%': [2000000, 250000],
                'max': this.priceTo
            },
            format: wNumb({
                decimals: 0,
                thousand: ' ',
            })
        });

        //set values from slider
        var paddingMin = document.getElementById('price_slider--min_price');
        var paddingMax = document.getElementById('price_slider--max_price');

        limitSlider.noUiSlider.on('update', function (values, handle) {
            if (handle) {
                paddingMax.innerHTML = values[handle];
                self.selectedPriceTo = parseInt(values[handle].replace(' ', '').replace(' ', ''));
            } else {
                paddingMin.innerHTML = values[handle];
                self.selectedPriceFrom = parseInt(values[handle].replace(' ', '').replace(' ', ''));
            }
        });

        limitSlider.noUiSlider.on('change', function (values, handle) {
            if (self.isFullSearch) {
                self.confirmFullSearch(false, false);
            }
        });
    }

    if (this.engineCapacitySliderEl.length) {
        // engineCapacity slider
        var limitSlider2 = document.getElementById(this.engineCapacitySliderEl.attr('id'));

        noUiSlider.create(limitSlider2, {
            start: [this.selectedEngineCapacityFrom, this.selectedEngineCapacityTo],
            behaviour: 'drag',
            connect: true,
            step: 100,
            range: {
                'min': this.engineCapacityFrom,
                'max': this.engineCapacityTo
            },
            format: wNumb({
                decimals: 0,
                thousand: ' ',
            })
        });

        //set values from slider
        var paddingMin2 = document.getElementById('engine_capacity_slider--min_engine_capacity');
        var paddingMax2 = document.getElementById('engine_capacity_slider--max_engine_capacity');

        limitSlider2.noUiSlider.on('update', function (values, handle) {
            if (handle) {
                paddingMax2.innerHTML = values[handle];
                self.selectedEngineCapacityTo = parseInt(values[handle].replace(' ', '').replace(' ', ''));
            } else {
                paddingMin2.innerHTML = values[handle];
                self.selectedEngineCapacityFrom = parseInt(values[handle].replace(' ', '').replace(' ', ''));
            }
        });

        limitSlider2.noUiSlider.on('change', function (values, handle) {
            if (self.isFullSearch) {
                self.confirmFullSearch(false, false);
            }
        });
    }

}

Search.prototype.setSelects = function (hideFirst) {
    // $('select.select2-container').on("select2-open", function (e) {
    //     if (hideFirst && $(this).hasClass('hideFirst') && $(window).width() > 750) {
    //         $('ul.select2-results li').first().css('display', 'none');
    //     }
    //     $(e.currentTarget).parent().find('i.fa').rotate(180);
    // });
    // $('select.select2-container').on("select2-close", function (e) {
    //     $(e.currentTarget).parent().find('i.fa').rotate(0);
    // });
    // this.initSearchBrandCareer();
}

Search.prototype.initSearch = function () {
    var self = this;
    self.initTogglers(false);
    self.initSelectZnacka();
    self.setSelects(false);
    self.initChangeColorAfterChange();

    // if ($(window).width() < 1290) {
    //     $(".advancedSearch2").addClass("active");
    //     $('.search-block-easy').removeClass("active");
    //     $('.search-block-full').addClass("active");
    // }

    $('.btnSearch').on('click', function (e) {
        e.preventDefault();
        var hasParams = false;
        var hasUrlPart = false;
        var url = '';

        if (self.lang !== 'cs') {
            url = '/' + self.lang;
        }

        var hasOtherUrl = $(this).data('url') !== undefined;
        if (hasOtherUrl) {
            url += $(this).data('url');
            hasUrlPart = true;
        }

        var isAdvaced = $(".advancedSearch2").hasClass('active');
        var query = '';

        var znackaVals = $('select.select2-container.selectZnacka').select2('val');
        var isZnackaArray = Array.isArray(znackaVals);
        var modelVals = $('select.select2-container.selectModel').select2('val');
        // vice modelu jedne znacky (Galaxy + S-MAX) taky nejde do cesty /ford/galaxy,
        // takze o query variante je treba rozhodnout uz pred znackou
        var hasMultiSelect = (isZnackaArray && znackaVals.length > 1) || (Array.isArray(modelVals) && modelVals.length > 1);
        var znackaVal = '';

        if (hasMultiSelect) {
            var znackaTexts = [];
            znackaVals.forEach(function (item) {
                znackaTexts.push(self.webalize($('select.select2-container.selectZnacka option[value="' + item + '"]').text()));
            });
            znackaVal = znackaTexts.join('|');
        } else {
            if (isZnackaArray) {
                znackaVal = znackaVals.shift();
            } else {
                znackaVal = znackaVals;
            }
            znackaVal = self.webalize($('select.select2-container.selectZnacka option[value="' + znackaVal + '"]').text());
        }

        if (znackaVal !== '') {
            if (hasOtherUrl || hasMultiSelect) {
                query += (hasParams ? '&' : '?') + 'znacka=' + znackaVal;
                hasParams = true;
            } else {
                url += '/' + znackaVal;
                hasUrlPart = true;
            }
        }

        var modelVal = '';

        if (hasMultiSelect) {
            var modelTexts = [];
            modelVals.forEach(function (item) {
                modelTexts.push(item);
            });
            modelVal = modelTexts.join('|');
        } else {
            modelVal = modelVals.shift();
            modelVal = self.webalize($('select.select2-container.selectModel option[value="' + modelVal + '"]').text());
        }

        if (modelVal !== '') {
            if (hasOtherUrl || hasMultiSelect) {
                query += (hasParams ? '&' : '?') + 'model=' + modelVal;
                hasParams = true;
            } else {
                url += '/' + modelVal;
                hasUrlPart = true;
            }
        }

        if ($('select.select2-container.selectKaroserie').length) {
            var karoserieVal = $('select.select2-container.selectKaroserie').select2('val');
            if (karoserieVal !== '') {
                url += '/' + self.webalize($('select.select2-container.selectKaroserie option[value="' + karoserieVal + '"]').data('value'));
                hasUrlPart = true;
            }
        }

        if ($('select.select2-container.selectPalivo').length) {
            var palivoVal = $('select.select2-container.selectPalivo').select2('val');
            if (palivoVal !== '') {
                url += '/' + self.webalize($('select.select2-container.selectPalivo option[value="' + palivoVal + '"]').data('value'));
                hasUrlPart = true;
            }
        }

        if (!hasUrlPart) {
            url = url + '/vsechna-auta';
        }

        url += query;

        // if (self.selectedPriceFrom !== self.priceFrom) {
        //     url += (hasParams ? '&cena_od=' : '?cena_od=') + self.selectedPriceFrom;
        //     hasParams = true;
        // }
        //
        // if (self.selectedPriceTo !== self.priceTo) {
        //     url += (hasParams ? '&cena_do=' : '?cena_do=') + self.selectedPriceTo;
        //     hasParams = true;
        // }

        var cenaOdVal = $('select.select2-container.selectCenaOd').select2('val');
        if (cenaOdVal !== '') {
            url += (hasParams ? '&cena_od=' : '?cena_od=') + cenaOdVal;
            hasParams = true;
        }

        var cenaDoVal = $('select.select2-container.selectCenaDo').select2('val');
        if (cenaDoVal !== '') {
            url += (hasParams ? '&cena_do=' : '?cena_do=') + cenaDoVal;
            hasParams = true;
        }

        var rokOdVal = $('select.select2-container.selectRokOd').select2('val');
        if (rokOdVal !== '') {
            url += (hasParams ? '&rok_od=' : '?rok_od=') + rokOdVal;
            hasParams = true;
        }

        var rokDoVal = $('select.select2-container.selectRokDo').select2('val');
        if (rokDoVal !== '') {
            url += (hasParams ? '&rok_do=' : '?rok_do=') + rokDoVal;
            hasParams = true;
        }

        var prevodovkaVal = $('select.select2-container.selectPrevodovka').select2('val');
        if (prevodovkaVal !== '') {
            url += (hasParams ? '&prevodovka=' : '?prevodovka=') + prevodovkaVal;
            hasParams = true;
        }

        if (isAdvaced) {

            // if (self.selectedEngineCapacityFrom !== self.engineCapacityFrom) {
            //     url += (hasParams ? '&objem_od=' : '?objem_od=') + self.selectedEngineCapacityFrom;
            //     hasParams = true;
            // }
            //
            // if (self.selectedEngineCapacityTo !== self.engineCapacityTo) {
            //     url += (hasParams ? '&objem_do=' : '?objem_do=') + self.selectedEngineCapacityTo;
            //     hasParams = true;
            // }
            var osbahOdDoVal = $('select.select2-container.selectObsahOdDo').select2('val');
            if (osbahOdDoVal !== '') {
                url += (hasParams ? '&objem_od_do=' : '?objem_od_do=') + osbahOdDoVal;
                hasParams = true;
            }

            var barvaVal = $('select.select2-container.selectBarva').select2('val');
            if (barvaVal !== '') {
                url += (hasParams ? '&barva=' : '?barva=') + barvaVal;
                hasParams = true;
            }
        } else {
            // if ($('select.select2-container.selectCena').length) {
            //     var cenaVal = $('select.select2-container.selectCena').select2('val');
            //     if (cenaVal !== '') {
            //         var prices = self.webalize($('select.select2-container.selectCena option[value="' + cenaVal + '"]').text()).split('-');
            //         if (prices.length === 3) {
            //             if ($.isNumeric(prices[0]) && prices[0] == "1") {
            //                 url += '/?cena_do=' + prices[1] + prices[2];
            //             } else {
            //                 url += '/?cena_od=' + prices[1] + prices[2];
            //             }
            //         } else {
            //             url += '/?cena_od=' + prices[0] + prices[1] + '&cena_do=' + prices[2] + prices[3];
            //         }
            //     }
            // }
            //
            // if ($('select.select2-container.selectRok').length) {
            //     var rokVal = $('select.select2-container.selectRok').select2('val');
            //     if (rokVal !== '') {
            //         url += (cenaVal !== '' ? '&rok_od=' : '/?rok_od=') + rokVal;
            //     }
            // }
        }


        // var cenaVal = $('select.select2-container.selectCena').select2('val');
        // if (cenaVal !== '') {
        //     var prices = self.webalize($('select.select2-container.selectCena option[value="' + cenaVal + '"]').text()).split('-');
        //     if (prices.length === 3) {
        //         if ($.isNumeric(prices[0]) && prices[0] == "1") {
        //             url += '/?cena_do=' + prices[1] + prices[2];
        //         } else {
        //             url += '/?cena_od=' + prices[1] + prices[2];
        //         }
        //     } else {
        //         url += '/?cena_od=' + prices[0] + prices[1] + '&cena_do=' + prices[2] + prices[3];
        //     }
        // }
        //
        // var rokVal = $('select.select2-container.selectRok').select2('val');
        // if (rokVal !== '') {
        //     url += (cenaVal !== '' ? '&rok_od=' : '/?rok_od=') + rokVal;
        // }

        // window.location.href = window.location.protocol + '//' + window.location.hostname + (window.location.port != '' ? ':' + window.location.port : '') + url;
        self.gtmEventClickBtnSearch();


        window.location.href = $('#autoesaUrl').val() + url;
    });
}

Search.prototype.gtmEventClickBtnSearch = function () {
    dataLayer.push({
        'event': 'gaEvent',
        'gaEventData': {
            'eCat': 'Button',
            'eAct': 'Button-form',
            'eLab': 'Vyhledat'
        }
    });
}

Search.prototype.initSearchFull = function () {
    var self = this;
    if ($("#categoryId").length) {
        self.tmpCategoryId = $("#categoryId").val();
    } else {
        self.tmpCategoryId = null;
    }

    self.isActionCars = $(".initSearchFull").data('action') == '1';
    self.initTogglers(true);
    self.initStickySearch();
    self.initSelectPreselected();
    self.initSelectZnacka();
    self.initDisableNonsensicalValuesFromSelect('selectCenaOd', 'selectCenaDo');
    self.initDisableNonsensicalValuesFromSelect('selectRokOd', 'selectRokDo');
    self.initDisableNonsensicalValuesFromSelect('selectMistOd', 'selectMistDo');
    self.initButtonRemoveFilter();
    self.reloadClickRemoveHeadFilter();
    self.initMainSearchBtn();
    self.initChangeColorAfterChange();
    self.enadblAjaxPaginator();
    self.enadblAjaxViewType();
    self.setSelects(true);
    $('.btnSearchFull').on('click', function (e) {
        e.preventDefault();
        self.confirmFullSearch(false, false);
    });
    $('.confirmFullSearch').on('change', function () {
        self.confirmFullSearch(false, false);
    });
    $('.confirmFullSearchCheckbox').on('change', function () {
        self.confirmFullSearch(false, false);
    });
    $('.confirmFullSearch2').on('change', function () {
        self.confirmFullSearch(true, false);
    });
    $('.confirmFullSearchDir').on('click', function (e) {
        e.preventDefault();
        $('.confirmFullSearchDir').removeClass('active');
        $(this).addClass('active');
        self.confirmFullSearch(true, false);
    });
}

Search.prototype.reload = function () {
    var self = this;
    self.enadblAjaxPaginator();
    self.enadblAjaxViewType();
    $('.confirmFullSearchCheckbox').on('change', function () {
        self.confirmFullSearch(false, false);
    });

    $('.car_item__title').matchHeight();
    $('.car_item__brand').matchHeight();
    $('.car_item__icons').matchHeight();
    $('.tags_akce').matchHeight();
}

Search.prototype.enadblAjaxPaginator = function () {
    var self = this;
    $('.pagination a').on('click', function () {
        self.prependOverlayContent();
        if (history.pushState) {
            window.history.pushState({}, "", $(this).attr('href'));
        }

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".scrollHere").offset().top
        }, 1000);
    });
}

Search.prototype.enadblAjaxViewType = function () {
    var self = this;
    $('.setViewType').on('click', function (e) {
        e.preventDefault();
        self.confirmFullSearch(true, $(this).parent().data('type'));
        // self.prependOverlayContent();
        // if (history.pushState) {
        //     window.history.pushState({}, "", $(this).attr('href'));
        // }
        //
        // $([document.documentElement, document.body]).animate({
        //     scrollTop: $(".scrollHere").offset().top
        // }, 1000);
    });
}


Search.prototype.confirmFullSearch = function (enableSortWithActualUrl, viewType) {
    console.log('VIEW');
    console.log(viewType);
    var self = this;
    var url = '';
    var hasParams = false;
    var hasUrlPart = false;
    var zobrazeniDefault = $('.seach_head_type').data('default');

    var zobrazeniVal = $('.seach_head_type_link--active').data('type');
    var razeniVal = $('select.select2-container.selectOrder').select2('val');

    if (enableSortWithActualUrl && (window.location.pathname.indexOf('/podobne-vozy/') > -1 || window.location.pathname.indexOf('/hledani') > -1 || window.location.pathname.indexOf('/predvyber') > -1)) {
        url = window.location.pathname;
        if (window.location.pathname.indexOf('/hledani') > -1) {
            url += (hasParams ? '&q=' : '?q=') + this.getParameterByName('q');
            hasParams = true;
        }

        if (zobrazeniVal != zobrazeniDefault || viewType) {
            url += (hasParams ? '&zobrazeni=' : '?zobrazeni=') + (viewType ? viewType : zobrazeniVal);
            hasParams = true;
        }

        if (razeniVal !== '4') {
            url += (hasParams ? '&razeni=' : '?razeni=') + razeniVal;
            hasParams = true;
        }

        if ($('.orderDown.active').length > 0) {
            url += (hasParams ? '&smer=' : '?smer=') + 'asc';
        }

        self.changeCarList(window.location.protocol + '//' + window.location.hostname + (window.location.port != '' ? ':' + window.location.port : '') + url);
        return;
    }

    var isPredvyber = $('select.select2-container.selectPredvyber').length > 0 && $('select.select2-container.selectPredvyber').select2('val') !== '';
    if (isPredvyber) {
        url = $('select.select2-container.selectPredvyber option[value="' + $('select.select2-container.selectPredvyber').select2('val') + '"]').data('url');
    }

    var showUvFilter = $('body').hasClass('uv') || (isPredvyber && $('select.select2-container.selectPredvyber').select2('val') === 'Užitkové vozy');
    if (showUvFilter) {
        $('select.select2-container.selectNajetoDo').parent().addClass('hidden');
        $('select.select2-container.selectVykonOd').parent().addClass('hidden');
    } else {
        $('select.select2-container.selectNajetoDo').parent().removeClass('hidden');
        $('select.select2-container.selectVykonOd').parent().removeClass('hidden');
    }

    if (self.lang !== 'cs' && !isPredvyber) {
        url = '/' + self.lang;
    }

    if (self.isActionCars) {
        isPredvyber = true;
        url += '/akcni-vozy';
    }

    var query = '';

    var znackaVals = $('select.select2-container.selectZnacka').select2('val');
    var isZnackaArray = Array.isArray(znackaVals);
    var modelVals = $('select.select2-container.selectModel').select2('val');
    // vice modelu jedne znacky (Galaxy + S-MAX) taky nejde do cesty /ford/galaxy,
    // takze o query variante je treba rozhodnout uz pred znackou
    var hasMultiSelect = (isZnackaArray && znackaVals.length > 1) || (Array.isArray(modelVals) && modelVals.length > 1);
    var znackaVal = '';

    if (hasMultiSelect || isPredvyber) {
        var znackaTexts = [];
        znackaVals.forEach(function (item) {
            znackaTexts.push(self.webalize($('select.select2-container.selectZnacka option[value="' + item + '"]').text()));
        });
        znackaVal = znackaTexts.join('|');
    } else {
        if (isZnackaArray) {
            znackaVal = znackaVals.shift();
        } else {
            znackaVal = znackaVals;
        }
        znackaVal = self.webalize($('select.select2-container.selectZnacka option[value="' + znackaVal + '"]').text());
    }

    // if (znackaVal !== '') {
    if ((!self.isSkoda && znackaVal !== '') || (self.isSkoda && !isPredvyber)) {
        if (isPredvyber || hasMultiSelect) {
            query += (hasParams ? '&' : '?') + 'znacka=' + znackaVal;
            hasParams = true;
        } else {
            url += '/' + znackaVal;
            hasUrlPart = true;
        }
    }

    // if ((!self.isSkoda && znackaVal !== '') || (self.isSkoda && !isPredvyber)) {
    //     url += (isPredvyber ? '?znacka=' : '/') + self.webalize($('select.select2-container.selectZnacka option[value="' + znackaVal + '"]').text());
    //     hasParams = isPredvyber ? true : false;
    //     hasUrlPart = true;
    // }

    var modelVal = '';

    if (hasMultiSelect || isPredvyber) {
        var modelTexts = [];
        modelVals.forEach(function (item) {
            modelTexts.push(item);
        });
        modelVal = modelTexts.join('|');
    } else {
        modelVal = modelVals.shift();
        modelVal = self.webalize($('select.select2-container.selectModel option[value="' + modelVal + '"]').text());
    }

    if (modelVal !== '') {
        if (isPredvyber || hasMultiSelect) {
            query += (hasParams ? '&' : '?') + 'model=' + modelVal;
            hasParams = true;
        } else {
            url += '/' + modelVal;
            hasUrlPart = true;
        }
    }

    // var modelVal = $('select.select2-container.selectModel').select2('val');
    // if (modelVal !== '') {
    //     url += (isPredvyber ? (hasParams ? '&' : '?') + 'model=' : '/') + self.webalize($('select.select2-container.selectModel option[value="' + modelVal + '"]').text());
    //     hasParams = isPredvyber ? true : false;
    //     hasUrlPart = true;
    // }

    var val = '';

    var karoserieVal = $('select.select2-container.selectKaroserie').select2('val');
    if (karoserieVal !== '') {
        val = self.webalize($('select.select2-container.selectKaroserie option[value="' + karoserieVal + '"]').data('value'));
        if (isPredvyber) {
            query += (hasParams ? '&' : '?') + 'karoserie=' + val;
            hasParams = true;
        } else {
            url += '/' + val;
            hasUrlPart = true;
        }
    }

    var palivoVal = $('select.select2-container.selectPalivo').select2('val');
    if (palivoVal !== '') {
        val = self.webalize($('select.select2-container.selectPalivo option[value="' + palivoVal + '"]').data('value'));
        if (isPredvyber) {
            query += (hasParams ? '&' : '?') + 'palivo=' + val;
            hasParams = true;
        } else {
            url += '/' + val;
            hasUrlPart = true;
        }
    }

    if (!hasUrlPart && !isPredvyber) {
        url = '/vsechna-auta' + url;
    }

    url += query;
    //
    // if (self.selectedPriceFrom !== self.priceFrom) {
    //     url += (hasParams ? '&cena_od=' : '?cena_od=') + self.selectedPriceFrom;
    //     hasParams = true;
    // }
    //
    // if (self.selectedPriceTo !== self.priceTo) {
    //     url += (hasParams ? '&cena_do=' : '?cena_do=') + self.selectedPriceTo;
    //     hasParams = true;
    // }

    var cenaOdVal = $('select.select2-container.selectCenaOd').select2('val');
    if (cenaOdVal !== '') {
        url += (hasParams ? '&cena_od=' : '?cena_od=') + cenaOdVal;
        hasParams = true;
    }

    var cenaDoVal = $('select.select2-container.selectCenaDo').select2('val');
    if (cenaDoVal !== '') {
        url += (hasParams ? '&cena_do=' : '?cena_do=') + cenaDoVal;
        hasParams = true;
    }

    var rokOdVal = $('select.select2-container.selectRokOd').select2('val');
    if (rokOdVal !== '') {
        url += (hasParams ? '&rok_od=' : '?rok_od=') + rokOdVal;
        hasParams = true;
    }

    var rokDoVal = $('select.select2-container.selectRokDo').select2('val');
    if (rokDoVal !== '') {
        url += (hasParams ? '&rok_do=' : '?rok_do=') + rokDoVal;
        hasParams = true;
    }

    var prevodovkaVal = $('select.select2-container.selectPrevodovka').select2('val');
    if (prevodovkaVal !== '') {
        url += (hasParams ? '&prevodovka=' : '?prevodovka=') + prevodovkaVal;
        hasParams = true;
    }

    if (!showUvFilter) {
        var vykonOdVal = $('select.select2-container.selectVykonOd').select2('val');
        if (vykonOdVal !== '') {
            url += (hasParams ? '&vykon_od=' : '?vykon_od=') + vykonOdVal;
            hasParams = true;
        }
    }

    if (!showUvFilter) {
        var osbahOdDoVal = $('select.select2-container.selectObsahOdDo').select2('val');
        if (osbahOdDoVal !== '') {
            url += (hasParams ? '&objem_od_do=' : '?objem_od_do=') + osbahOdDoVal;
            hasParams = true;
        }
    }

    if (!showUvFilter) {
        var najetoDoVal = $('select.select2-container.selectNajetoDo').select2('val');
        if (najetoDoVal !== '') {
            url += (hasParams ? '&najeto_do=' : '?najeto_do=') + najetoDoVal;
            hasParams = true;
        }
    }

    // if (self.selectedEngineCapacityFrom !== self.engineCapacityFrom) {
    //     url += (hasParams ? '&objem_od=' : '?objem_od=') + self.selectedEngineCapacityFrom;
    //     hasParams = true;
    // }
    //
    // if (self.selectedEngineCapacityTo !== self.engineCapacityTo) {
    //     url += (hasParams ? '&objem_do=' : '?objem_do=') + self.selectedEngineCapacityTo;
    //     hasParams = true;
    // }

    var barvaVal = $('select.select2-container.selectBarva').select2('val');
    if (barvaVal !== '') {
        url += (hasParams ? '&barva=' : '?barva=') + barvaVal;
        hasParams = true;
    }

    // var mistVal = $('select.select2-container.selectMistDo').select2('val');
    // if (mistVal !== '') {
    //     url += (hasParams ? '&mist_do=' : '?mist_do=') + mistVal;
    //     hasParams = true;
    // }
    //
    // mistVal = $('select.select2-container.selectMistOd').select2('val');
    // if (mistVal !== '') {
    //     url += (hasParams ? '&mist_od=' : '?mist_od=') + mistVal;
    //     hasParams = true;
    // }

    var mistVal = $('select.select2-container.selectMist').select2('val');
    if (mistVal !== '') {
        url += (hasParams ? '&mist=' : '?mist=') + mistVal;
        hasParams = true;
    }

    var isChecked = $('input[type="checkbox"].checkMajitel').prop("checked");
    if (isChecked) {
        url += (hasParams ? '&majitel=1' : '?majitel=1');
        hasParams = true;
    }

    isChecked = $('input[type="checkbox"].checkNoveVCr').prop("checked");
    if (isChecked) {
        url += (hasParams ? '&nove_cr=1' : '?nove_cr=1');
        hasParams = true;
    }

    // isChecked = $('input[type="checkbox"].checkKniha').prop("checked");
    // if (isChecked) {
    //     url += (hasParams ? '&kniha=1' : '?kniha=1');
    //     hasParams = true;
    // }

    isChecked = $('input[type="checkbox"].checkOdpocetDPH').prop("checked");
    if (isChecked) {
        url += (hasParams ? '&odpocet=1' : '?odpocet=1');
        hasParams = true;
    }

    isChecked = $('input[type="checkbox"].check4x4').prop("checked");
    if (isChecked) {
        url += (hasParams ? '&4x4=1' : '?4x4=1');
        hasParams = true;
    }

    var vybava = [];
    $('input[type="checkbox"].vybava:checked').each(function (index) {
        vybava[index] = $(this).val();
    });
    if (vybava.length > 0) {
        url += (hasParams ? '&vybava=' + vybava.join('_') : '?vybava=' + vybava.join('_'));
        hasParams = true;
    }

    if (zobrazeniVal != zobrazeniDefault || viewType) {
        url += (hasParams ? '&zobrazeni=' : '?zobrazeni=') + (viewType ? viewType : zobrazeniVal);
        hasParams = true;
    }

    if (razeniVal !== '0') {
        url += (hasParams ? '&razeni=' : '?razeni=') + razeniVal;
        hasParams = true;
    }

    if ($('.orderDown.active').length > 0) {
        url += (hasParams ? '&smer=' : '?smer=') + 'asc';
        hasParams = true;
    }

    self.changeCarList(window.location.protocol + '//' + window.location.hostname + (window.location.port != '' ? ':' + window.location.port : '') + url);
}

Search.prototype.changeCarList = function (url) {
    // console.log(url);
    // return;
    var self = this;
    $.nette.ajax({
        type: 'GET',
        url: url,
        beforeSend: function () {
            self.prependOverlayContent();
            if ($(window).width() < 1083) {
                $('.search').slideUp();
                $(this).removeClass("active");
            }
        },
        success: function () {
            if (history.pushState) {
                window.history.pushState({}, "", url);
            }
            $('.animateAjaxSearch').prop("disabled", false);
            $('.overlayContent .loader-wrapper').remove();

            var viewportWidth = parseInt($(window).width());
            if (viewportWidth > 1199) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".search_right_column").offset().top
                }, 500);
            }
        }
    }).done(function () {
        if ($("#isCarSold").length) {
            if ($("#isCarSold").val() === 'true') {
                $('.list-cars-header').addClass('hidden');
            } else {
                $('.list-cars-header').removeClass('hidden');
            }
        }

        if (self.isFullSearch) {
            // self.pushDataLayerCategory();
            self.reloadClickRemoveHeadFilter();
        }
    });
}

Search.prototype.prependOverlayContent = function () {
    if (!$('.overlayContent .loader-wrapper').length) {
        var html = '<div class="loader-wrapper"><div class="loader-circle-wrapper"><div class="loader-circle"></div></div></div>';
        $('.overlayContent').prepend(html);
        $('.animateAjaxSearch').prop("disabled", true);
    }
}

Search.prototype.initSelectPreselected = function () {
    var self = this;
    $('select.select2-container.selectPredvyber').on('change', function () {
        if (self.isFullSearch) {
            self.changeSelectZnacka();
        } else {
            self.changeSelectKaroserie();
        }
        // $('select.select2-container.selectZnacka').trigger('click');
    });
}

Search.prototype.initSelectZnacka = function () {
    var self = this;
    $('select.select2-container.selectZnacka').on('change', function () {//.off('change')
        self.chancheModels();
    });
}

Search.prototype.chancheModels = function () {
    var self = this;
    var selectZnacka = $('select.select2-container.selectZnacka');
    var selectModel = $('select.select2-container.selectModel');

    if (selectZnacka.select2("val")) {
        var preselectedValue = $('select.select2-container.selectPredvyber').length && $('select.select2-container.selectPredvyber').select2('val') !== '' ? $('select.select2-container.selectPredvyber').select2('val') : '';

        let znacky = selectZnacka.select2("val");
        for (let index = 0; index < znacky.length; ++index) {
            znacky[index] = znacky[index].replace('x', '');
        }

        var data = {
            'znackaDialId': znacky,//$(selectZnacka).val(),
        };
        if (preselectedValue) {
            data = {
                'znackaDialId': $(selectZnacka).val(),
                'preselected': preselectedValue,
            };
        }

        self.prependOverlayContent();
        $.nette.ajax({
            url: $('#getModelsLink').val(),
            data: data,
            success: function (payload) {
                // var defaultText = $('select.select2-container.selectModel option:first-child').html();
                // console.log(defaultText);

                var modelVal = $('select.select2-container.selectModel').select2('val');

                selectModel.empty();
                // var option = new Option(defaultText, '', false, false);
                // selectModel.append(option);

                var hasSelected = false;
                $.each(payload.groups, function (key, group) {
                    if (payload.groupsCount > 1) {

                        var optGroup = document.createElement('optgroup');
                        optGroup.setAttribute('label', group.name);

                        $.each(group.models, function (key, value) {
                            var selected = false;
                            if (modelVal && modelVal.includes(value.key)) {
                                selected = true;
                                hasSelected = true;
                            }

                            var option = new Option(value.val, value.key, false, selected);
                            optGroup.append(option);
                        });
                        selectModel.append(optGroup);
                    } else {
                        $.each(group.models, function (key, value) {
                            var selected = false;
                            if (modelVal && modelVal.includes(value.key)) {
                                selected = true;
                                hasSelected = true;
                            }

                            var option = new Option(value.val, value.key, false, selected);
                            selectModel.append(option);
                        });
                    }
                });

                if (!hasSelected) {
                    selectModel.parent().find('.del_filter').remove();
                    selectModel.removeClass('select-container-color-text-red');
                }

            },
        }).done(function () {
            self.prependOverlayContent();
            self.changeSelectKaroserie();
        });
    } else {
        // $("select.select2-container.selectModel").parent().find('.del_filter').remove();
        var defaultText = $('select.select2-container.selectModel option:first-child').html();

        selectModel.empty();
        var option = new Option(defaultText, '', false, false);
        selectModel.append(option);

        selectZnacka.parent().find('.del_filter').remove();
        selectZnacka.removeClass('select-container-color-text-red');

        selectModel.parent().find('.del_filter').remove();
        selectModel.removeClass('select-container-color-text-red');

        var isPreselectedSelected = $('select.select2-container.selectPredvyber').length && $('select.select2-container.selectPredvyber').select2('val') !== '';
        if (isPreselectedSelected) {
            self.changeSelectKaroserie();
        }
    }
}

Search.prototype.changeSelectZnacka = function () {
    var self = this;
    var brandVal = $('select.select2-container.selectZnacka').select2('val');
    var isPreselectedSelected = $('select.select2-container.selectPredvyber').length && $('select.select2-container.selectPredvyber').select2('val') !== '';

    var selectZnacka = $('select.select2-container.selectZnacka');

    $.nette.ajax({
        url: $('#getBrandsLink').val(),
        data: {
            'preselected': isPreselectedSelected ? $('select.select2-container.selectPredvyber option[value="' + $('select.select2-container.selectPredvyber').select2('val') + '"]').text() : '',
        },
        success: function (payload) {
            var defaultText = $('select.select2-container.selectZnacka option:first-child').html();

            selectZnacka.empty();
            var option = new Option(defaultText, '', false, false);
            selectZnacka.append(option);

            $.each(payload.brands, function (key, value) {
                var selected = false;
                if (value.key == brandVal && brandVal) {
                    selected = true;
                }

                var option = new Option(value.val, value.key, false, selected);
                if (value.key == '') {
                    option.setAttribute('disabled', 'disabled')
                }
                selectZnacka.append(option);
            });
        }
    }).done(function () {
        if (self.isFullSearch) {
            self.chancheModels();
        }
    });
}


Search.prototype.changeSelectKaroserie = function () {
    var self = this;
    var caroseryVal = $('select.select2-container.selectKaroserie').select2('val');
    var brandVal = $('select.select2-container.selectZnacka').select2('val');
    var isBrandSelected = brandVal !== [];
    var modelVal = $('select.select2-container.selectModel').select2('val');
    var isModelSelected = modelVal !== [];
    var isPreselectedSelected = $('select.select2-container.selectPredvyber').length && $('select.select2-container.selectPredvyber').select2('val') !== '';

    var selectKaroserie = $('select.select2-container.selectKaroserie');

    var brands = [];
    // var models = [];
    //
    if (isBrandSelected) {
        for (let index = 0; index < brandVal.length; ++index) {
            brands[index] = self.webalize($('select.select2-container.selectZnacka option[value="' + brandVal[index] + '"]').text())
        }
    }
    //
    // if (isModelSelected) {
    //     for (let index = 0; index < modelVal.length; ++index) {
    //         models[index] = modelVal[index]
    //     }
    // }
    //
    // console.log(brands);
    // console.log(models);


    $.nette.ajax({
        url: $('#getCaroseriesLink').val(),
        data: {
            'znacka': brands,
            'model': modelVal,
            'preselected': isPreselectedSelected ? self.webalize($('select.select2-container.selectPredvyber option[value="' + $('select.select2-container.selectPredvyber').select2('val') + '"]').text()) : '',
        },
        success: function (payload) {
            // $('select.select2-container.selectKaroserie').select2('destroy');
            // $('select.select2-container.selectKaroserie option').not(':eq(0)').remove();
            // var hasCarosery = false;

            var defaultText = $('select.select2-container.selectKaroserie option:first-child').html();

            selectKaroserie.empty();
            var option = new Option(defaultText, '', false, false);
            selectKaroserie.append(option);
            var wasSelected = false;
            $.each(payload.models, function (key, value) {
                var selected = false;
                if (key == caroseryVal) {
                    // hasCarosery = true;
                    selected = true;
                    wasSelected = true;
                }

                var option = new Option(value.value, key, false, selected);
                option.setAttribute('data-value', value.default)
                selectKaroserie.append(option);

                // $('select.select2-container.selectKaroserie')
                //     .append($("<option></option>")
                //         .attr("value", key)
                //         .data('value', value.default)
                //         .text(value.value));
            });

            // console.log(wasSelected);
            if (!wasSelected) {
                $("select.select2-container.selectKaroserie").parent().find('.del_filter').remove();
                // $("select.select2-container.selectKaroserie").val(null).trigger('change');
                $("select.select2-container.selectKaroserie").removeClass('select-container-color-text-red');
            }

//             if ($(window).width() > 600) {
//                 $("select.select2-container.selectKaroserie").select2({
//                     theme: "bootstrap",
//                     formatNoMatches: function () {
//                         return $('#tans_nenalezen_zaznam').val();
//                     },
//                     matcher: function (term, text) {
// // console.log(term);
// // console.log(text);
//                         if (term.length === 0)
//                             return true;
//                         texts = text.split(" ");
//                         allCombinations = permute(texts, [], []);
//                         for (i in allCombinations) {
//                             if (allCombinations[i].join(" ").toUpperCase().indexOf(term.toUpperCase()) === 0) {
//                                 return true;
//                             }
//                         }
//                         return false;
//                     }
//                 });
//             } else {
//                 $("select.select2-container.selectKaroserie").select2({
//                     theme: "bootstrap",
//                     minimumResultsForSearch: -1
//                 }).on('select2-opening', function () {
//                     $(this).siblings('select.select2-container').find('.select2-search').remove();
//                 });
//             }

            // if (hasCarosery) {
            //     $("select.select2-container.selectKaroserie").select2('val', caroseryVal);
            //     $("select.select2-container.selectKaroserie").find('.select2-chosen').addClass('select-container-color-text-red');
            //     $("select.select2-container.selectKaroserie").find('i.fa').addClass('select-container-color-text-red');
            // } else {
            //     $("select.select2-container.selectKaroserie").parent().find('.del_filter').remove();
            // }
        }
    }).done(function () {
        if (self.isFullSearch) {
            self.confirmFullSearch(false, false);
        }
    });
}

Search.prototype.pushDataLayerCategory = function () {
    if ($("#categoryId").length) {
        var self = this;
        setTimeout(function () {
            var catId = $("#categoryId").val();
            if (self.tmpCategoryId != catId) {
                dataLayer.push({
                    "rtbHouse": catId,
                    "rtbHouse_category": catId
                });
                self.tmpCategoryId = catId;
            }

        }, 1000);
    }
}


Search.prototype.initDisableNonsensicalValuesFromSelect = function (classSelectFrom, classSelectTo) {
    var valFrom = parseInt($('select.select2-container.' + classSelectFrom).select2('val'));
    $('select.select2-container.' + classSelectTo + ' option').each(function () {
        if ($(this).val() < valFrom && $(this).val() != '') {
            $(this).attr('disabled', 'disabled');
        } else {
            $(this).removeAttr('disabled');
        }
    });
    var valTo = parseInt($('select.select2-container.' + classSelectTo).select2('val'));
    $('select.select2-container.' + classSelectFrom + ' option').each(function () {
        if ($(this).val() > valTo && $(this).val() != '') {
            $(this).attr('disabled', 'disabled');
        } else {
            $(this).removeAttr('disabled');
        }
    });
    $('select.select2-container.' + classSelectFrom).change(function () {
        var valFrom = parseInt($(this).select2('val'));
        if ($('select.select2-container.' + classSelectTo).select2('val') < valFrom) {
            $('select.select2-container.' + classSelectTo).select2('val', '');
            $('select.select2-container.' + classSelectTo).parent().find('.select2-chosen').removeClass('select-container-color-text-red');
        }

        $('select.select2-container.' + classSelectTo + ' option').each(function () {
            if ($(this).val() < valFrom && $(this).val() != '') {
                $(this).attr('disabled', 'disabled');
            } else {
                $(this).removeAttr('disabled');
            }
        });
    });
    $('select.select2-container.' + classSelectTo).change(function () {
        var valTo = parseInt($(this).select2('val'));
        if ($('select.select2-container.' + classSelectFrom).select2('val') > valTo) {
            $('select.select2-container.' + classSelectFrom).select2('val', '');
            $('select.select2-container.' + classSelectFrom).parent().find('.select2-chosen').removeClass('select-container-color-text-red');
        }

        $('select.select2-container.' + classSelectFrom + ' option').each(function () {
            if ($(this).val() > valTo && $(this).val() != '') {
                $(this).attr('disabled', 'disabled');
            } else {
                $(this).removeAttr('disabled');
            }
        });
    });
}

Search.prototype.disableNonsensicalValuesFromSelect = function (classSelectFrom, classSelectTo) {
    var valFrom = parseInt($('select.select2-container.' + classSelectFrom).select2('val'));
    $('select.select2-container.' + classSelectTo + ' option').each(function () {
        if ($(this).val() < valFrom && $(this).val() != '') {
            $(this).attr('disabled', 'disabled');
        } else {
            $(this).removeAttr('disabled');
        }
    });
    var valTo = parseInt($('select.select2-container.' + classSelectTo).select2('val'));
    $('select.select2-container.' + classSelectFrom + ' option').each(function () {
        if ($(this).val() > valTo && $(this).val() != '') {
            $(this).attr('disabled', 'disabled');
        } else {
            $(this).removeAttr('disabled');
        }
    });
}

Search.prototype.initChangeColorAfterChange = function () {
    var self = this;

    $('.search_box select.select2-container').not('.select2-multiple2').each(function (index) {
        if ($(this).val() != '') {
            $(this).addClass('select-container-color-text-red');
        } else {
            $(this).removeClass('select-container-color-text-red');
        }
    });

    $('.search_box select.select2-container').not('.select2-multiple2').on('change', function () {
        if ($(this).select2("val") != '') {
            $(this).addClass('select-container-color-text-red');
        } else {
            $(this).removeClass('select-container-color-text-red');
        }

        if ($(this).hasClass('selectModel')) {
            self.prependOverlayContent();
            self.changeSelectKaroserie();
        }
    });

    $('.search_box select.select2-container.select2-multiple2').each(function (index) {
        if ($(this).val()) {
            $(this).addClass('select-container-color-text-red');
        } else {
            $(this).removeClass('select-container-color-text-red');
        }
    });

    $('.search_box select.select2-container.select2-multiple2').on('change', function () {
        if ($(this).select2("val")) {
            $(this).addClass('select-container-color-text-red');
        } else {
            $(this).removeClass('select-container-color-text-red');
        }

        if ($(this).hasClass('selectModel')) {
            self.prependOverlayContent();
            self.changeSelectKaroserie();
        }
    });
}

Search.prototype.initButtonRemoveFilter = function () {
    var self = this;
    self.reloadClickRemoveFilter();
    $('.search_box.initSearchFull select.select2-container').on('change', function () {
        if ($(this).select2("val") != '') {
            if (!$(this).parent().find('.del_filter').length) {
                $(this).parent().append('<span class="del_filter' + ($(this).hasClass('small') ? ' small' : '') + '"></span>');
                self.reloadClickRemoveFilter();
            }
        } else {
            $(this).parent().find('.del_filter').remove();
        }
    });
}

Search.prototype.reloadClickRemoveFilter = function () {
    var self = this;
    $('.del_filter').off('click').on('click', function () {
        var isPredvyber = $(this).parent().find("select.select2-container").hasClass('selectPredvyber');
        var isBrand = $(this).parent().find("select.select2-container").hasClass('selectZnacka');
        var isModel = $(this).parent().find("select.select2-container").hasClass('selectModel');


        $(this).parent().find('select.select2-container').val(null).trigger('change');
        $(this).parent().find('select.select2-container').removeClass('select-container-color-text-red');
        $(this).remove();

        if (isBrand) {
            $("select.select2-container.selectModel").parent().find('.del_filter').remove();
            $("select.select2-container.selectModel").val(null).trigger('change');
            $("select.select2-container.selectModel").removeClass('select-container-color-text-red');

            $('select.select2-container.selectModel').empty();

            // self.changeSelectKaroserie();
        }

        if (isPredvyber) {
            self.changeSelectZnacka();
        } else if (isBrand || isModel) {
            self.changeSelectKaroserie();
        } else {
            self.confirmFullSearch(false, false);
        }

        if ($(this).parent().find("select.select2-container").hasClass('selectCenaOd') || $(this).parent().find("select.select2-container").hasClass('selectCenaDo')) {
            self.disableNonsensicalValuesFromSelect('selectCenaOd', 'selectCenaDo');
        }

        if ($(this).parent().find("select.select2-container").hasClass('selectRokOd') || $(this).parent().find("select.select2-container").hasClass('selectRokDo')) {
            self.disableNonsensicalValuesFromSelect('selectRokOd', 'selectRokDo');
        }

        if ($(this).parent().find("select.select2-container").hasClass('selectMistOd') || $(this).parent().find("select.select2-container").hasClass('selectMistDo')) {
            self.disableNonsensicalValuesFromSelect('selectMistOd', 'selectMistDo');
        }
    });
}

Search.prototype.reloadClickRemoveHeadFilter = function () {
    var self = this;
    $('.head_def_filter').off('click').on('click', function () {
        console.log($(this).hasClass('head_def_filter_all'));
        if ($(this).hasClass('head_def_filter_all')) {
            $(this).parent().remove();

            var isPredvyber = false;
            var isBrand = false;
            var isModel = false;


            // if (self.priceSliderEl.length) {
            //     // price slider
            //     var limitSlider = document.getElementById(self.priceSliderEl.attr('id'));
            //
            //     //set values from slider
            //     var paddingMin = document.getElementById('price_slider--min_price');
            //     var paddingMax = document.getElementById('price_slider--max_price');
            //
            //     var priceTo = self.priceTo + '';
            //     var priceFrom = self.priceFrom + '';
            //     limitSlider.noUiSlider.set([self.priceFrom, self.priceTo]);
            //     paddingMax.innerHTML = self.priceTo;
            //     self.selectedPriceTo = priceTo ? parseInt(priceTo.replace(' ', '').replace(' ', '')) : 0;
            //     paddingMin.innerHTML = self.priceFrom;
            //     self.selectedPriceFrom = priceFrom ? parseInt(priceFrom.replace(' ', '').replace(' ', '')) : 0;
            // }
            //
            // if (self.engineCapacitySliderEl.length) {
            //     // price slider
            //     var limitSlider2 = document.getElementById(self.engineCapacitySliderEl.attr('id'));
            //
            //     //set values from slider
            //     var paddingMin2 = document.getElementById('engine_capacity_slider--min_engine_capacity');
            //     var paddingMax2 = document.getElementById('engine_capacity_slider--max_engine_capacity');
            //
            //     var engineCapacityTo = self.engineCapacityTo + '';
            //     var engineCapacityFrom = self.engineCapacityFrom + '';
            //     limitSlider2.noUiSlider.set([self.engineCapacityFrom, self.engineCapacityTo]);
            //     paddingMax2.innerHTML = self.engineCapacityTo;
            //     self.selectedEngineCapacityTo = engineCapacityTo ? parseInt(engineCapacityTo.replace(' ', '').replace(' ', '')) : 0;
            //     paddingMin2.innerHTML = self.engineCapacityFrom;
            //     self.selectedEngineCapacityFrom = engineCapacityFrom ? parseInt(engineCapacityFrom.replace(' ', '').replace(' ', '')) : 0;
            // }

            $('.del_filter').each(function (index) {
                isPredvyber = isPredvyber || $(this).parent().find("select.select2-container").hasClass('selectPredvyber');
                isBrand = isBrand || $(this).parent().find("select.select2-container").hasClass('selectZnacka');
                isModel = isModel || $(this).parent().find("select.select2-container").hasClass('selectModel');

                $(this).parent().find('select.select2-container').val(null).trigger('change');
                $(this).parent().find('select.select2-container').removeClass('select-container-color-text-red');
                $(this).remove();

                if (isBrand) {
                    $("select.select2-container.selectModel").parent().find('.del_filter').remove();
                    $("select.select2-container.selectModel").val(null).trigger('change');
                    $("select.select2-container.selectModel").removeClass('select-container-color-text-red');
                    $('select.select2-container.selectModel').empty();
                }

                if ($(this).parent().find("select.select2-container").hasClass('selectCenaOd') || $(this).parent().find("select.select2-container").hasClass('selectCenaDo')) {
                    self.disableNonsensicalValuesFromSelect('selectCenaOd', 'selectCenaDo');
                }

                if ($(this).parent().find("select.select2-container").hasClass('selectRokOd') || $(this).parent().find("select.select2-container").hasClass('selectRokDo')) {
                    self.disableNonsensicalValuesFromSelect('selectRokOd', 'selectRokDo');
                }

                if ($(this).parent().find("select.select2-container").hasClass('selectMistOd') || $(this).parent().find("select.select2-container").hasClass('selectMistDo')) {
                    self.disableNonsensicalValuesFromSelect('selectMistOd', 'selectMistDo');
                }
            });

            $('.checkboxs_holder input[type=checkbox]').prop('checked', false);
            // $(this).remove();
            // elSelect.prop('checked', false);
            // elSelect.trigger("change");(function (index) {
            // $('.del_filter').each(function (index) {
            //     elSelect.prop('checked', false);
            //     elSelect.trigger("change");
            // });

            if (isPredvyber) {
                self.changeSelectZnacka();
            } else if (isBrand || isModel) {
                self.changeSelectKaroserie();
            } else {
                self.confirmFullSearch(false, false);
            }

        } else {
            var elClass = $(this).data('select');
            switch (elClass) {
                // case '.selectPriceFrom':
                //     if (self.priceSliderEl.length) {
                //         // price slider
                //         var limitSlider = document.getElementById(self.priceSliderEl.attr('id'));
                //
                //         //set values from slider
                //         var paddingMin = document.getElementById('price_slider--min_price');
                //         var paddingMax = document.getElementById('price_slider--max_price');
                //
                //         var priceTo = self.selectedPriceTo + '';
                //         var priceFrom = self.priceFrom + '';
                //         limitSlider.noUiSlider.set([priceFrom, priceTo]);
                //         paddingMax.innerHTML = priceTo;
                //         self.selectedPriceTo = priceTo ? parseInt(priceTo.replace(' ', '').replace(' ', '')) : 0;
                //         paddingMin.innerHTML = priceFrom;
                //         self.selectedPriceFrom = priceFrom ? parseInt(priceFrom.replace(' ', '').replace(' ', '')) : 0;
                //
                //         $(this).remove();
                //         self.confirmFullSearch(false, false);
                //     }
                //     break;
                // case '.selectPriceTo':
                //     if (self.priceSliderEl.length) {
                //         // price slider
                //         var limitSlider = document.getElementById(self.priceSliderEl.attr('id'));
                //
                //         //set values from slider
                //         var paddingMin = document.getElementById('price_slider--min_price');
                //         var paddingMax = document.getElementById('price_slider--max_price');
                //
                //         var priceTo = self.priceTo + '';
                //         var priceFrom = self.selectedPriceFrom + '';
                //         limitSlider.noUiSlider.set([priceFrom, priceTo]);
                //         paddingMax.innerHTML = priceTo;
                //         self.selectedPriceTo = priceTo ? parseInt(priceTo.replace(' ', '').replace(' ', '')) : 0;
                //         paddingMin.innerHTML = priceFrom;
                //         self.selectedPriceFrom = priceFrom ? parseInt(priceFrom.replace(' ', '').replace(' ', '')) : 0;
                //
                //         $(this).remove();
                //         self.confirmFullSearch(false, false);
                //     }
                //     break;
                // case '.selectEngineCapacityFrom':
                //     if (self.engineCapacitySliderEl.length) {
                //         // engineCapacity slider
                //         var limitSlider = document.getElementById(self.engineCapacitySliderEl.attr('id'));
                //
                //         //set values from slider
                //         var paddingMin = document.getElementById('engine_capacity_slider--min_engine_capacity');
                //         var paddingMax = document.getElementById('engine_capacity_slider--max_engine_capacity');
                //
                //         var engineCapacityTo = self.selectedEngineCapacityTo + '';
                //         var engineCapacityFrom = self.engineCapacityFrom + '';
                //         console.log(engineCapacityFrom);
                //         console.log(engineCapacityTo);
                //         limitSlider.noUiSlider.set([engineCapacityFrom, engineCapacityTo]);
                //         paddingMax.innerHTML = engineCapacityTo;
                //         self.selectedEngineCapacityTo = engineCapacityTo ? parseInt(engineCapacityTo.replace(' ', '').replace(' ', '')) : 0;
                //         paddingMin.innerHTML = engineCapacityFrom;
                //         self.selectedEngineCapacityFrom = engineCapacityFrom ? parseInt(engineCapacityFrom.replace(' ', '').replace(' ', '')) : 0;
                //
                //         $(this).remove();
                //         self.confirmFullSearch(false, false);
                //     }
                //     break;
                // case '.selectEngineCapacityTo':
                //     if (self.engineCapacitySliderEl.length) {
                //         // engineCapacity slider
                //         var limitSlider = document.getElementById(self.engineCapacitySliderEl.attr('id'));
                //
                //         //set values from slider
                //         var paddingMin = document.getElementById('engine_capacity_slider--min_engine_capacity');
                //         var paddingMax = document.getElementById('engine_capacity_slider--max_engine_capacity');
                //
                //         var engineCapacityTo = self.engineCapacityTo + '';
                //         var engineCapacityFrom = self.selectedEngineCapacityFrom + '';
                //         limitSlider.noUiSlider.set([engineCapacityFrom, engineCapacityTo]);
                //         paddingMax.innerHTML = engineCapacityTo;
                //         self.selectedEngineCapacityTo = engineCapacityTo ? parseInt(engineCapacityTo.replace(' ', '').replace(' ', '')) : 0;
                //         paddingMin.innerHTML = engineCapacityFrom;
                //         self.selectedEngineCapacityFrom = engineCapacityFrom ? parseInt(engineCapacityFrom.replace(' ', '').replace(' ', '')) : 0;
                //
                //         $(this).remove();
                //         self.confirmFullSearch(false, false);
                //     }
                //     break;
                default:
                    var elSelect = $(elClass);
                    if (elSelect.prop("tagName") === 'INPUT') {
                        $(this).remove();
                        elSelect.prop('checked', false);
                        elSelect.trigger("change");
                    } else {
                        var val = '' + $(this).data('key');
                        $(this).remove();

                        var data = elSelect.val();
                        if (Array.isArray(data) && data.length !== 1) {
                            if (data.indexOf(val) >= 0) {
                                data.splice(data.indexOf(val), 1);
                            }
                            if (data.indexOf(val + 'x') >= 0) {
                                data.splice(data.indexOf(val + 'x'), 1);
                            }

                            elSelect.val(data).trigger("change");
                        } else {
                            elSelect.parent().find('.del_filter').trigger('click');
                        }
                    }
            }

        }
    });
}

Search.prototype.webalize = function (s) {
    if (s === '/')
        return s;
    var nodiac = {
        'á': 'a',
        'č': 'c',
        'ď': 'd',
        'é': 'e',
        'ě': 'e',
        'í': 'i',
        'ň': 'n',
        'ó': 'o',
        'ř': 'r',
        'š': 's',
        'ť': 't',
        'ú': 'u',
        'ů': 'u',
        'ý': 'y',
        'ž': 'z',
        'ë': 'e'
    };
    s = s.toLowerCase();
    var s2 = '';
    for (var i = 0; i < s.length; i++) {
        s2 += (typeof nodiac[s.charAt(i)] != 'undefined' ? nodiac[s.charAt(i)] : s.charAt(i));
    }
    return s2.replace(/[^a-z0-9_]+/g, '-').replace(/^-|-$/g, '');
}


Search.prototype.getParameterByName = function (name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// Search.prototype.initSearchBrandCareer = function () {
//     if ($('select.select2-container.select-brand-career').length && window.location.hash !== '') {
//         $('html, body').animate({
//             scrollTop: $(window.location.hash).offset().top
//         }, 1000);
//     }
//     $('select.select2-container.select-brand-career').on('change', function () {
//         hash = $(this).select2("val");
//         if (hash != '') {
//             $('html, body').animate({
//                 scrollTop: $(hash).offset().top
//             }, 1000);
//             window.location.hash = hash;
//         }
//     });
// }

Search.prototype.initTogglers = function (isFullSearch) {
    var self = this;

    // toggle search
    $('.search_box_toggler').click(function () {
        $(".search_box").slideToggle();
        return false;
    })

    // advenced search toggler
    if ($(".search_box .advenced_search_toggler").length) {
        $('.search_box .advenced_search_toggler a').click(function () {
            $(this).toggleClass("active");
            $(".search_box .advenced_search_toggle_content").slideToggle("normal", function () {
                if (isFullSearch) {
                    // self.stickySearch();
                }
            });
            return false;
        })
    }
}

Search.prototype.initMainSearchBtn = function () {
    var self = this;

    $('.mainSearchBtn').click(function () {
        var viewportWidth = parseInt($(window).width());
        if (viewportWidth < 1200) {
            $(".search_box").slideUp(300, function () {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".search_right_column").offset().top
                }, 300);
            });
        } else {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".search_right_column").offset().top
            }, 500);
        }
        self.gtmEventClickBtnSearch();
        self.confirmFullSearch(false, false);
    });

    // advenced search toggler
    // if ($(".search_box .advenced_search_toggler").length) {
    //     $('.search_box .advenced_search_toggler a').click(function () {
    //         $(this).toggleClass("active");
    //         $(".search_box .advenced_search_toggle_content").slideToggle();
    //         if (isFullSearch) {
    //             self.stickySearch();
    //         }
    //         return false;
    //     })
    // }
}

Search.prototype.initStickySearch = function () {
    var self = this;

    var viewportWidth = parseInt($(window).width());
    if (viewportWidth >= 1200) {
        $('.search_left_column_wrapper').stickySidebar({
            topSpacing: 0,
            bottomSpacing: 0,
            resizeSensor: true,
            innerWrapperSelector: '.stickySearch',
        });
        $(".stickySearchWrapper").removeClass("fixed");
    } else {
        self.fixedSearch();
        $(window).on('scroll', function () {
            self.fixedSearch();
        });
    }
}

Search.prototype.fixedSearch = function () {
    var y_scroll_pos = window.pageYOffset;
    var scroll_pos_test = $("#stickySearchWrapperFix").offset();
    if (y_scroll_pos > scroll_pos_test.top) {
        $(".stickySearchWrapper").addClass("fixed");
    } else {
        $(".stickySearchWrapper").removeClass("fixed");
    }
}


Search.prototype.initMultiSelect = function () {
    $.fn.select2.amd.require([
        'select2/selection/single',
        'select2/selection/placeholder',
        'select2/selection/allowClear',
        'select2/dropdown',
        'select2/dropdown/search',
        'select2/dropdown/attachBody',
        'select2/utils'
    ], function (SingleSelection, Placeholder, AllowClear, Dropdown, DropdownSearch, AttachBody, Utils) {

        var SelectionAdapter = Utils.Decorate(
            SingleSelection,
            Placeholder
        );

        SelectionAdapter = Utils.Decorate(
            SelectionAdapter,
            AllowClear
        );

        var DropdownAdapter = Utils.Decorate(
            Utils.Decorate(
                Dropdown,
                DropdownSearch
            ),
            AttachBody
        );

        var base_element = $('.select2-multiple2')
        $(base_element).select2({
            placeholder: base_element.data('placeholder'),
            selectionAdapter: SelectionAdapter,
            dropdownAdapter: DropdownAdapter,
            templateResult: function (data) {

                if (!data.id) {
                    return data.text;
                }

                var $res = $('<div></div>');

                $res.text(data.text);
                $res.addClass('wrap');

                return $res;
            },
            templateSelection: function (data) {
                var selfEl = $(data.element).closest('.select2-container')

                if (!data.id) {
                    return data.text;
                }
                var selected = (selfEl.val() || []).length;
                // var total = $('option', $(selfEl)).length;

                if (selected > 4) {
                    return "Vybráno " + selected + " položek";
                } else if (selected > 1) {
                    return "Vybrány " + selected + " položky";
                } else if (selected > 0) {
                    return data.text;
                } else {
                    return selfEl.data('placeholder');
                }
            }
        })

        // Google Translate: container/dropdown multi-selectu značky/modelu vznikají
        // až tady po initu, označíme je jako notranslate (helper je v main.js modulu).
        if (window.markBrandModelNoTranslate) {
            window.markBrandModelNoTranslate(base_element.filter('.selectZnacka, .selectModel'));
        }

    })
}